export class ApiParameters
{
    private readonly parameters: Map<string, string | number>;

    public constructor()
    {
        this.parameters = new Map<string, string | number>();
    }

    public addQueryParameter(key: string, value: string | number): ApiParameters
    {
        this.parameters.set(key, value);
        return this;
    }

    public getQueryString(): string
    {
        const queryParameterList = Array.from(this.parameters)
            .reduce<string[]>((accumulator: string[], current: [string, string | number]) =>
            {
                accumulator.push(`${current[0]}=${current[1].toString()}`);
                return accumulator;
            }, []);

        if (queryParameterList.length === 0)
        {
            return '';
        }

        return queryParameterList.join('&');
    }
}
